import { VideoFeedStatic } from "./VideoFeedStatic";
import * as Icons_SVG from "@core/GUI/Utils/IconsSVG";
import * as FlvJs from "BaseRoulette/Embed/flv.js";
import { videoVolume } from "@core/Utils/Constants";
import { Client } from "@core/Client";

/*
* Flv.js player implementation using nginx http-flv streaming
*/
export class VideoFeedFLV extends VideoFeedStatic {

    private baseUrl = Client.logic.h264videoURL;
    private playPromise: any;
    private playerIsPlaying: boolean = false;
    private player;
    private videoQuality: integer = 1;//active stream quality
    private maxVideoQuality: integer = 2;//total number of available stream qualities-1
    private qualityTransmuxSpeedThreshold: integer[] = [250, 110, 60];//average kb/s required to be fed into transmuxer per quality, lower than this means video lag.
    private transmuxSpeedHistory: integer[] = [];
    private silhouette = `<div id="silhouette_display_div" style="display: none; border-bottom: ${this.borderSize}px solid black; width: ${this.videoWidth}px; height: ${this.videoHeight}px; ">
								<div style="position: absolute; top: -99px; left: -11px">
									<div id="silhouette_play_button" style="transform: scale(0.9)">	
										${Icons_SVG.Silhouette_PLAY}
									</div>
								</div>
							</div>`
    private voidWarningFLVDIV = `<div class="void-warning">
                                    ${this.voidWarningTextSVG}
                                </div>`

    constructor(private _videoContainer: string, scene: Phaser.Scene) {
        super(_videoContainer, scene)

        this.HTML = `
        ${this.latencyWarning}
        <div draggable="false" class="unselectable" id="video_refresh_button" style="display: none; position: absolute; z-index: 9998; bottom: 15px; right: 15px; color: white;">
            <img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable" style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);" width="50px" id="refresh_video_button" src='data:image/svg+xml;utf8,${this.scene.game.device.os.iOS ? Icons_SVG.RefreshSVG : Icons_SVG.FullscreenSVG}' />
        </div>
        <div draggable="false" class="unselectable" id="video_stop_button" style="position: absolute; z-index: 9998; bottom: 15px; right: 15px; color: white;">
            <img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable" style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);" width="50px" id="stop_video_button" src='${Icons_SVG.PauseButton}' />
        </div>

        <div id="video-loader" style="background-color: black; width: 100%; height: 100%; position: absolute; z-index: -1; border-radius: 5px;">
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>

        <video id="iframe_video_stream" preload="auto" class="centeredVideo" autoplay style="object-fit: fill;border: ${this.borderSize}px solid ${this.borderColor}; border-radius: 5px; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: -moz-none; -o-user-select: none; user-select: none; pointer-events: none" src="/embed_autoplay.html" width="` + this.videoWidth + `" height="` + this.videoHeight + `" frameborder="0" scrolling="no" style="overflow: hidden;"></video>
                             
        <div draggable="false" class="unselectable" id="global_mute_unmute_button" style="display: none; position: absolute; z-index: 9998; top: 5px; left: 15px; color: white;">
            <img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable" style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);" width="50px" id="global_mute_unmute_button" src='data:image/svg+xml;utf8,${Icons_SVG.SpeakerOn}' />
        </div>
        ${this.voidWarningFLVDIV}
        ${this.silhouette}`
        this.videoContainer.innerHTML = this.HTML;

        this.PlayerPlay();

        setInterval(() => {
            this.FlvProgressListen()
        }, 5000)
    }

    handleDown(e): void {
        super.handleDown(e);

        if (e.target.id == "stop_video_button") {
            this.PlayerStop();
            return
        }

        if (e.target.id == "path0" || e.target.id == "playButton" || e.target.id == "pathPlayButton") {
            this.player.muted = false;
            this.PlayerPlay();
            return
        }
    }

    StopVideo(): void {
        this.hidePlayerDIV()
        this.showSilhouetteDIV()
        this.silhouetteVisible = true
        this.PlayerStop();
    }

    PlayVideo(): void {
        this.silhouetteVisible = false
        this.Show()
        this.PlayerPlay();
    }

    // Must exist otherwise an exception will be thrown causing game breaking issues for iOS devices
    TryUnlockingAudioAfterGesture(): void {

    }

    MuteAudioIFrame(): void {

    }

    UnMuteAudioIFrame(): void {

    }

    Hide(forced: boolean): void {
        this.PlayerStop();

        if (forced) {
            this.hideSilhouetteDIV()
            this.hidePlayerDIV()

            this.visible = false
            this.softHidden = false
        }
        else {
            this.showSilhouetteDIV()
            this.hidePlayerDIV()

            this.visible = false
            this.softHidden = false
        }
    }

    Show(): void {
        this.baseUrl = Client.logic.h264videoURL;
        this.videoContainer.style.display = "block"

        if (this.silhouetteVisible) {
            this.showSilhouetteDIV()
        } else {
            this.hideSilhouetteDIV()
            this.showPlayerDIV()
            // Verjetno je prav
            this.PlayerPlay();
        }
        this.visible = true
        this.softHidden = false

        // this.PlayerPlay();
        return;
    }

    private hidePlayerDIV(): void {
        document.getElementById("iframe_video_stream").style.display = "none"
        document.getElementById("video-loader").style.display = "none"
        document.getElementById("video_stop_button").style.display = "none"
    }

    private showPlayerDIV(): void {
        document.getElementById("iframe_video_stream").style.display = "block"
        document.getElementById("video-loader").style.display = "block"
        document.getElementById("video_stop_button").style.display = "block"
    }

    private hideSilhouetteDIV(): void {
        document.getElementById("silhouette_display_div").style.display = "none"
    }

    private showSilhouetteDIV(): void {
        document.getElementById("silhouette_display_div").style.display = "block"
    }

    /*--------------------FLVjs Player functions--------------------*/
    /**
     * Starts flv player, playing the given url (lowest quality as default). 
     * If there is no player instance it creates a new player.
     */
    private PlayerPlay(): void {
        if (this.playerIsPlaying || this.player)
            return;

        if (!this.player) {
            if (typeof this.player !== "undefined") {
                try {
                    this.player.unload();
                } catch (e) { }
                try {
                    this.player.detachMediaElement();
                } catch (e) { }
                try {
                    this.player.destroy();
                } catch (e) { }
                try {
                    this.player = null;
                } catch (e) { }
            }
            this.player = (FlvJs as any).createPlayer({
                type: 'flv',
                isLive: true,
                hasVideo: true,
                hasAudio: true,
                url: this.getStreamUrl(),
                lazyload: false,
                seekType: 'range',
                enableStashBuffer: false,
                enableWorker: true,
                accurateSeek: true,
            });
            this.player.attachMediaElement(document.getElementById('iframe_video_stream'));
        }
        this.player.volume = videoVolume;
        this.player.load();
        this.playPromise = this.player.play();
        this.playerIsPlaying = true;

        this.player.on((FlvJs as any).Events.ERROR, (errorType, errorDetail, errorInfo) => this.FlvErrorListen(errorType, errorDetail, errorInfo));
        //this.player.on((FlvJs as any).Events.PROGRESS, () => this.FlvProgressListen());
    }
    /**
     * Stops flv player fully
     */
    private PlayerStop(): void {
        if (!this.playerIsPlaying || !this.player)
            return;

        if (this.playPromise !== undefined) {
            this.playPromise.then(_ => {
                this.player.pause();
                this.player.unload();
                this.player.detachMediaElement();
                this.player.destroy();
                this.player = null;
            })
                .catch(error => {
                    console.log(error);
                });
        }
        if (typeof this.player !== "undefined") {
            this.player.unload();
            this.player.detachMediaElement();
            this.player.destroy();
            this.player = null;

        }
        this.playerIsPlaying = false;
    }
    /**
     * Flv player error listener
     */
    private errorReloadingPlayer = false;
    private FlvErrorListen(errorType, errorDetail, errorInfo): void {
        if (errorInfo.msg == "Failed to fetch" && !this.errorReloadingPlayer) {
            this.errorReloadingPlayer = true;
            console.log("Failed to fetch stream - Reloading player.");
            this.PlayerStop();
            this.PlayerPlay();

            setTimeout(() => { this.errorReloadingPlayer = false }, 5000);
        }
    }

    private FlvProgressListen(): void {
        try {
            if (this.player && this.playerIsPlaying) {
                var end = this.player.buffered.end(0);
                var delta = end - this.player.currentTime;
                if (delta > 0.7) {
                    this.player.currentTime = (end - 0.2)
                }
            }
        }
        catch (e) {
        }
    }

    /*--------------------Utils/Helper functions--------------------*/
    private lowerVideoQuality() {
        if ((this.videoQuality - 1) < 0) {
            return;
        }
        else {
            this.videoQuality -= 1;
        }
    }
    private increaseVideoQuality() {
        if ((this.videoQuality + 1) > this.maxVideoQuality) {
            return;
        }
        else {
            this.videoQuality += 1;
        }
    }
    /**
    * Returns assembled url based on quality settings.
    * Default is lowest quality.
    */
    private getStreamUrl(): string {
        let returnUrl = this.baseUrl + 'live?port=1965&app=live&stream=stream';

        switch (this.videoQuality) {
            case 0:
                returnUrl += "Low";
                break;
            case 1:
                returnUrl += "Medium";
                break;
            case 2:
                //highest quality is named "stream" at the moment for testing purposes, so no need to append anything
                break;
            default:
                returnUrl += "Low";
                break;
        }
        return returnUrl;
    }

    override setVideoVolume(value: number): void {
        if (this.player)
            this.player.volume = value;
    }
}